var render, staticRenderFns
import script from "./_tentativas.vue?vue&type=script&lang=ts"
export * from "./_tentativas.vue?vue&type=script&lang=ts"
import style0 from "./_tentativas.vue?vue&type=style&index=0&id=f7f065fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports